/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./n20Card.vue?vue&type=template&id=1bb0a6d0&scoped=true"
import script from "./n20Card.vue?vue&type=script&lang=js"
export * from "./n20Card.vue?vue&type=script&lang=js"
import style0 from "./n20Card.vue?vue&type=style&index=0&id=1bb0a6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0a6d0",
  null
  
)

export default component.exports